import { createSlice } from '@reduxjs/toolkit';

import {
  serviceGetDocument,
} from 'utils';

const initialState = {
  data: null,
  isLoaded: {
    get: false,
  },
  success: {
    get: false,
  },
  error: {
    get: false,
  },
}

const documentSlice = createSlice({
  name: 'document',
  initialState,
  reducers: {
    dataRequest(state, action) {
      return { ...state, isLoaded: { ...state.isLoaded, [action.payload]: true } };
    },

    dataSuccess(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        success: { ...state.success, [action.payload.fetchType]: true },
        data: action.payload.data || null,
      };
    },

    dataFailure(state, action) {
      return {
        ...state,
        isLoaded: { ...state.isLoaded, [action.payload.fetchType]: false },
        error: { ...state.error, [action.payload.fetchType]: action.payload.data?.message },
      };
    },

    cleanUpDocument(state) {
      return initialState;
    },

    cleanUpMessageDocument(state) {
      return {
        ...state,
        isLoaded: initialState.isLoaded,
        success: initialState.success,
        error: initialState.error,
      };
    },
  }
});

const {
  dataRequest,
  dataSuccess,
  dataFailure,
  cleanUpDocument,
  cleanUpMessageDocument
} = documentSlice.actions;

const fetchGetDocument = (query) => {
  return (dispatch) => {
    dispatch(dataRequest('get'));
    serviceGetDocument(query)
      .then((response) => dispatch(dataSuccess({data: response.data, fetchType: 'get'})))
      .catch((err) => dispatch(dataFailure({data: err, fetchType: 'get'})));
  };
};

export {
  fetchGetDocument,
  cleanUpDocument,
  cleanUpMessageDocument
};

export default documentSlice.reducer;
